import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from './ui/button';
import { User } from 'lucide-react';
import { DiscgoLogo } from './DiscgoLogo';

export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-gray-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <DiscgoLogo style={{ height: '53px', width: '53px' }} />
            </Link>
          </div>

          {/* Navigation Links and User Icon */}
          <div className="flex items-center space-x-8">
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('players')}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                players
              </button>
              <button
                onClick={() => scrollToSection('owners')}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                owners
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                features
              </button>
            </div>
            <Button
              onClick={() => navigate('/login')}
              variant="ghost"
              size="icon"
              className="rounded-full hover:bg-primary/10"
            >
              <User className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}